import React from 'react'

function ShipperPage() {
    return (
        <div></div>
    )
}

export default ShipperPage